import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import moment from "moment";

//material ui
import Modal from "@material-ui/core/Modal";
import { withStyles } from "@material-ui/core/styles";

import { queryStore, clearErrors } from "../../store/actions/UserActions";
import {
  clearTicketsLoaders,
  selectPage,
  setFilters,
  searchByID,
  filterTickets,
  pushTicket,
  setPage
} from "../../store/actions/TicketsActions";
import {
  getModalStyle,
  styles,
  formatDate,
  formatDateWithTime,
  formatPrice
} from "../../config";
import Filters from "../Filters/Filters";
import DatePicker from "../common/DatePicker/DatePicker";

import customStyles from "./TicketsView.module.css";
import TicketsList from "./TicketsList";
import { socket_connect, socket_disconnect } from "../../helpers/socket";
import { search, updateSearchQuery } from "../../store/actions/SearchActions";

class TicketsView extends Component {
  static status = {
    approved: <span className="label label-success">Approved</span>,
    pending: <span className="label label-warning">Pending</span>,
    denied: <span className="label label-danger">Denied</span>
  };

  static cards = {
    credit_card: <span className="label label-success">Credit Card</span>,
    fawry: <span className="label label-primary">Fawry/Aman</span>,
    // aman: <span className="label label-primary">Aman</span>,
    delivery: <span className="label label-primary">Delivery</span>
  };

  state = {
    isDatePickerActive: false,
    from: null,
    to: null,
    enteredTo: null,

    searchID: ""

    // socket io
  };

  io = null;

  componentDidMount() {
    this.io = socket_connect(this.socket_connected, this.socket_disconnected);
    this.props.searchTickets();
  }

  componentWillUnmount() {
    socket_disconnect(this.io);
  }

  socket_connected = () => {
    console.log("connected");
    this.io.on("new_ticket", this.socket_new_ticket);
  };

  socket_new_ticket = ticket => {
    try {
      if (typeof ticket === "string") {
        ticket = JSON.parse(ticket);
      }

      if (typeof ticket !== "object") {
        return console.error(`parsed invalid ticket: `, ticket);
      }

      this.props.pushTicket(ticket);
    } catch (err) {
      console.error(err);
      console.log(ticket);
    }
  };

  socket_disconnected = () => {
    console.log("disconnected");
  };

  // bound vars
  // searchQuery = this.defaultQuery();
  searchID = null;

  clearLoadersAndErrors = () => {
    this.props.clearTicketsLoaders();
    this.props.clearUserErrors();
  };

  searchByID = () => {
    if (!this.state.searchID || this.state.searchID === 0) return;

    console.log(`searching with id ${this.state.searchID}`);
    this.props.searchByID(this.state.searchID);
  };

  clearIDFilter = () => {
    this.setState({ searchID: "" });
    this.props.filterTickets();
  };

  setSearchID = e => {
    if (/^$|^[0-9]+/.test(e.target.value))
      this.setState({
        searchID: e.target.value
      });
  };

  /** Date Picker Methods */
  toggleDatePicker = state => {
    let targetState = !this.state.isDatePickerActive;

    if (typeof state === "boolean") targetState = state;
    this.setState({ isDatePickerActive: targetState });
  };

  setFromDate = day => {
    this.setState({
      from: day,
      to: null,
      enteredTo: null
    });

    this.setQuery({
      ActionDate: {
        $gte: moment(day).startOf('day').format()
      }
    });
  };

  setToDate = day => {
    this.setState({
      to: day,
      enteredTo: day,
      isDatePickerActive: false
    });

    this.setQuery({
      ActionDate: {
        $gte: this.props.searchStore.query.ActionDate.$gte,
        $lt: moment(day).endOf('day').format()
      }
    })
  };

  setEnteredTo = day => {
    this.setState({
      enteredTo: day
    });
  };

  resetDatePicker = () => {
    this.setState({
      from: null,
      to: null,
      enteredTo: null
    });

    this.setQuery({ ActionDate: this.props.searchStore.default_query.ActionDate });
    this.props.setPage(1);
  };
  /** Date Picker Methods */

  /** Query Store */
  setQuery = ( filters ) => {
    // this.searchQuery = {
    //   ...this.searchQuery,
    //   ...filters
    // }

    this.props.updateSearchQuery({
      ...this.props.searchStore.query,
      ...filters
    });
  }

  /** End of Query Store */

  render() {
    let ticketsStore = this.props.ticketsStore;
    let userStore = this.props.userStore;

    let tickets = [[]];

    if (ticketsStore.filtered_tickets) {
      tickets = ticketsStore.filtered_tickets;
    } else {
      tickets = ticketsStore.tickets;
    }

    return (
      <div className={`${customStyles.content_wrapper} content-wrapper`}>
        {this.renderModal(userStore, ticketsStore)}
        <section className={`content-header ${customStyles.view}`}>
          <div className="row">
            <div className="col-md-12">
              <h3 className={"box-title " + customStyles.box_title}>
                Booked Tickets
              </h3>
              <div className="box">
                <div className={"box-header " + customStyles.box_header}>
                  <Filters
                    setFilters={this.setQuery}
                    />
                  <div className={customStyles.tools_container}>
                    <div className={customStyles.box_tools_container}>
                      <div className={"box-tools " + customStyles.box_tools}>
                        <div
                          className={
                            "input-group input-group-sm " +
                            customStyles.input_group
                          }
                        >
                          <input
                            type="text"
                            name="table_search"
                            className="form-control pull-right"
                            placeholder="Pick a date range"
                            value={
                              this.state.from
                                ? `${formatDate(this.state.from)} ${
                                    this.state.to
                                      ? " - " + formatDate(this.state.to)
                                      : ""
                                  }`
                                : ""
                            }
                            title={
                              this.state.from
                                ? `${formatDate(this.state.from)} ${
                                    this.state.to
                                      ? " - " + formatDate(this.state.to)
                                      : ""
                                  }`
                                : undefined
                            }
                            onChange={() => {}}
                            onClick={this.toggleDatePicker}
                          />
                          <div className="input-group-btn">
                            <button
                              type="button"
                              className={`btn btn-${
                                this.state.from ? "danger" : "default"
                              }`}
                              onClick={() => {
                                if (this.state.from) {
                                  this.resetDatePicker();
                                } else {
                                  this.toggleDatePicker();
                                }
                              }}
                            >
                              <i
                                className={
                                  this.state.from
                                    ? `fa fa-times`
                                    : `fa fa-calendar-alt`
                                }
                              />
                            </button>
                          </div>
                        </div>
                        <DatePicker
                          isActive={this.state.isDatePickerActive}
                          from={this.state.from}
                          to={this.state.to}
                          enteredTo={this.state.enteredTo}
                          setFromDate={this.setFromDate}
                          setToDate={this.setToDate}
                          setEnteredTo={this.setEnteredTo}
                          close={this.toggleDatePicker.bind(this, false)}
                        />
                      </div>
                      <div className={"box-tools " + customStyles.box_tools}>
                        <div className="input-group input-group-sm">
                          <input
                            type="numeric"
                            name="table_search"
                            className="form-control pull-right"
                            value={this.state.searchID}
                            onChange={this.setSearchID}
                            placeholder="Search by ID"
                          />

                          <div className="input-group-btn">
                            <button
                              type="submit"
                              onClick={() => {
                                if (ticketsStore.filtered_by_id) {
                                  this.clearIDFilter();
                                } else {
                                  this.searchByID();
                                }
                              }}
                              className={`btn btn-${
                                ticketsStore.filtered_by_id
                                  ? "danger"
                                  : "default"
                              }`}
                            >
                              <i
                                className={`fa fa-${
                                  ticketsStore.filtered_by_id
                                    ? "times"
                                    : "search"
                                }`}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {ticketsStore.total_price !== 0 && (
                      <div
                        className={"box-tools price" + customStyles.box_tools}
                      >
                        <div
                          className={
                            "input-group input-group-sm " +
                            customStyles.total_price
                          }
                        >
                          {}
                          <label>Total:</label>
                          {formatPrice(ticketsStore.total_price)} EGP
                        </div>
                      </div>
                    )}

                    <button
                      className={`btn btn-block ${
                        userStore.querying_store ? "btn-default" : "btn-danger"
                      } ${customStyles.sync_btn}`}
                      disabled={userStore.querying_store}
                      onClick={this.props.searchTickets}
                    >
                      <i
                        className={`fas fa-sync ${
                          userStore.querying_store ? "spin" : ""
                        }`}
                      />
                      Search
                    </button>
                  </div>
                </div>
                <div className="box-body table-responsive no-padding">
                  <TicketsList
                    columns={this.props.ticketsStore.columns}
                    tickets={tickets}
                  />
                </div>
              </div>
              <div className="btn-group">
                {this.renderPageButtons()}
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  renderPageButtons = props => {
    let buttons = [];
    let total_pages = this.props.ticketsStore.total_pages;
    let current_page = this.props.ticketsStore.page;

    for(let i in _.range(0, total_pages)) {
      let classname = current_page === Number(i) + 1 ? "btn btn-danger" : "btn btn-default";
      buttons.push(
        <button
          key={i}
          className={classname}
          onClick={() => {
            this.props.selectPage(Number(i) + 1);
          }}
        >
          {Number(i) + 1}
        </button>
      );
    }
    return buttons;
  };
  renderModal = (userStore, ticketsStore) => {
    let ticketsDifference = ticketsStore.difference;

    return (
      <Modal
        open={
          ticketsStore.done_setting_tickets || userStore.query_error || false
        }
        onClose={this.clearLoadersAndErrors}
      >
        <div style={getModalStyle()} className={this.props.classes.paper}>
          {userStore.query_error ? (
            <h4>{userStore.query_error}</h4>
          ) : (
            <h4>
              Synced tickets,{" "}
              {ticketsDifference > 0 &&
                ` ${ticketsDifference} tickets where added.`}
              {ticketsDifference === 0 && ` no change found.`}
              {ticketsDifference < 0 &&
                ` ${ticketsDifference * -1} tickets where removed.`}
            </h4>
          )}
        </div>
      </Modal>
    );
  };
}

function mapStateToProps(store) {
  return {
    ticketsStore: store.tickets,
    userStore: store.user,
    searchStore: store.search
  };
}

function mapDispatchToProps(dispatch) {
  return {
    // userQueryStore: bindActionCreators(queryStore, dispatch),
    updateSearchQuery: bindActionCreators(updateSearchQuery, dispatch),
    searchTickets: bindActionCreators(search, dispatch),
    selectPage: bindActionCreators(selectPage, dispatch),
    setPage: bindActionCreators(setPage, dispatch),
    clearTicketsLoaders: bindActionCreators(clearTicketsLoaders, dispatch),
    clearUserErrors: bindActionCreators(clearErrors, dispatch),
    setFilters: bindActionCreators(setFilters, dispatch),
    searchByID: bindActionCreators(searchByID, dispatch),
    filterTickets: bindActionCreators(filterTickets, dispatch),
    pushTicket: bindActionCreators(pushTicket, dispatch)
  };
}

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TicketsView)
);
